<div class="flex justify-end">
  <app-close-chip (closed)="close()" />
</div>
<h2 mat-dialog-title>{{"components.amipass_recharge_modal.title" | translate}}</h2>
<mat-dialog-content class="!pt-2">
  <p class="text-sm font-normal text-default-gray m-0 mb-4" [innerHTML]="'components.amipass_recharge_modal.disclaimer' | translate"></p>
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>{{"components.amipass_recharge_modal.form_field_title" | translate}}</mat-label>
    <input matInput type="number" max="100000" [(ngModel)]="amount">
    <mat-hint [innerHTML]="'components.amipass_recharge_modal.form_field_hint' | translate: { minAmount: minimumRechargeAmount }"></mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" type="button" [disabled]="amount < minimumRechargeAmount || amount > maximumRechargeAmount" (click)="onSend()">
    {{ "components.amipass_recharge_modal.recharge_button" | translate | uppercase }}
  </button>
</mat-dialog-actions>
